import React from "react";
import { Box, Typography } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";

// Label and value rows with a hairline between them (Feedback rate 10982:85773: 8 px, the
// default line; Payout & compliance 10982:85907: 9 px, the subtle line; the ticket page's cards
// 10829:93565: the divider, and the secondary grey for the labels). `rows` is
// [{ key, label, value }].
const DetailRows = ({ rows, py = "8px", line = tokens.border.default, labelColor = tokens.text.tertiary }) => (
  <Box component="dl" sx={{ m: 0 }}>
    {rows.map((row, i) => (
      <Box
        key={row.key}
        sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: "12px", py, borderTop: i ? `1px solid ${line}` : "none" }}
      >
        <Typography component="dt" variant="bodySmall" sx={{ color: labelColor }}>
          {row.label}
        </Typography>
        <Typography component="dd" variant="bodySmallStrong" sx={{ m: 0, color: tokens.text.primary, textAlign: "right" }}>
          {row.value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default DetailRows;
